import React, { useState } from 'react';
import { Button, Input, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { BASE_URL } from '../../util/Constants';
import HTTP from '../../util/Http';

const ImageUploadDialog = ({ open, onClose, idactividad }) => {
  const [image, setImage] = useState(null);

  const handleClose = () => {
    onClose();
  };

  const handleImageChange = (event) => {
    const selectedImage = event.target.files[0];
    setImage(selectedImage);
  };

  const handleUpload = () => {
    if (!image) {
      // No image selected, handle accordingly
      return;
    }

    const formData = new FormData();
    formData.append('file', image);
    formData.append('id', idactividad);

    const url = BASE_URL + "actividad/uploadimage";
    HTTP.post(url, formData)
      .then((response) => {
        // Handle response from server
        console.log('Image uploaded!', response);
        // Additional logic here
        handleClose(); // Close the dialog after successful upload
      })
      .catch((error) => {
        // Handle errors
        console.error('Error uploading image', error);
      });
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Actualizar Imagen</DialogTitle>
        <DialogContent>
          <Input type="file" onChange={handleImageChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button variant="contained" color="primary" onClick={handleUpload}>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ImageUploadDialog;
